import React, { PureComponent, RefObject, createRef } from 'react';

import { YoutubeMetadata } from 'api';

import { YOUTUBE_ENDPOINT, YOUTUBE_HEIGHT } from '../constants';

interface IProps {
  id: YoutubeMetadata['video_id'];
}

class EmbedYouTube extends PureComponent<IProps> {
  container: RefObject<HTMLDivElement>;

  constructor(props: IProps) {
    super(props);
    this.container = createRef();
  }

  componentDidMount() {
    this.embedVideo();
  }

  embedVideo() {
    const { id } = this.props;
    const { current } = this.container;

    const iFrame = document.createElement('iframe');

    Object.assign(iFrame, {
      height: `${YOUTUBE_HEIGHT}px`,
      src: `${YOUTUBE_ENDPOINT}/${id}`,
      style: 'border: 0',
      width: '100%',
    });

    current.appendChild(iFrame);
  }

  render() {
    return <div ref={this.container} />;
  }
}

export default EmbedYouTube;
